export default "__VITE_ASSET__586df04b__"